import getEnvironmentVar from '../utils/getEnvironmentVar'

// Single source of truth for "launch day" - used to reset the global charts
// and to know when the %-change badges have a real prior day to compare
// against. month is 0-indexed (Date.UTC convention): 8 = September.
export const LAUNCH_DATE_UTC = { year: 2026, month: 7, day: 22 }

const BLACKLISTED_TOKENS = [
  '0x0bD8ddF29982Fcb8f80A0Ef18644C75Bb4F84413', // ITSAtoken mainnet
  '0xbD578Cb977E3260BAdCB9C62E6bbA1886a0002bB', // duplicate BNT token, should be hidden forever: https://git.energi.software/energi/defi/swap/info/-/issues/22
  '0xd9bAFd5e1Dd109B46207A42467be273f550FF676', // OKB temp blacklisted: remove from blacklist once it is minted
  '0xDb1895e9002d94247A5e0bA44df06d716da02f51', // BSV temp blacklisted: remove from blacklist once it is minted
  '0x1d2C216ee8121e6C1A20Ff9053819BeF3a64f29d', // HT temp blacklisted: remove from blacklist once it is minted
  '0x4778d9690cd7d9697107aEF080d5B908ABEbb83d', // LEO temp blacklisted: remove from blacklist once it is minted
  '0xad3EaC6a2EF827833880a10592C6E46605E4F9d6', // VGX temp blacklisted: remove from blacklist once it is minted
  '0x70ADA65dE12E5c0F6ff7E58Cad734a813cA50bf3', // AR temp blacklisted: remove from blacklist once it is minted
  '0x78C6efEB603e48C6F64EddEC7131FcA4915E2014', // MDX temp blacklisted: remove from blacklist once it is minted
  '0xD83EDa5A201532291c1fB71e6E3471b8EF3575aC', // NXM temp blacklisted: remove from blacklist once it is minted
  '0xb2b1F16b7bB342ADCb57671f5aBa0Ae160196b75', // LUNA: scam
]

const PROTECTED_TICKERS = [
  'WNRG',
  'MNRG',
  'e1INCH',
  'eAAVE',
  'eBTC',
  'eDAI',
  'eETH',
  'eLINK',
  'eSNX',
  'eUNI',
  'eYFI',
  'eDOT',
  'eBNB',
  'eAVAX',
  'eCRV',
  'eLTC',
  'eBCH',
  'eDOGE',
  'eCAKE',
  'eADA',
  'eXRP',
  'eXLM',
  'eDASH',
  'eXMR',
  'eATOM',
  'eSUSHI',
  'eBADGER',
  'eLRC',
  'eBAL',
  'eRUNE',
  'eGRT',
  'eFIL',
  'eXEM',
  'eHEGIC',
  'eSOL',
  'eBNT',
  'eDODO',
  'eMKR',
  'eNEO',
  'eEOS',
  'eMIOTA',
  'eXTZ',
  'eTHETA',
  'eCOMP',
  'eTRX',
  'eOKB',
  'eCRO',
  'eVET',
  //'eLUNA',
  'eBSV',
  'eHT',
  'eFTT',
  'eEGLD',
  'eKSM',
  'eDCR',
  'eLEO',
  'eCEL',
  'eZIL',
  'eSTX',
  'eZEC',
  'eVGX',
  'eNEAR',
  'eRVN',
  'eETC',
  'eFTM',
  'eNEXO',
  'eENJ',
  'eUMA',
  'eHBAR',
  'eCHSB',
  'eICX',
  'eMATIC',
  'eZRX',
  'eBAT',
  'eWAVES',
  'eREN',
  'eIOST',
  'eALGO',
  'eBTT',
  'eONT',
  'eAMP',
  'eDGB',
  'eNANO',
  'eZKS',
  'eOMG',
  'eQTUM',
  'eAR',
  'eMDX',
  'eCHZ',
  'eHOT',
  'eRSR',
  'eEWT',
  'eSC',
  'eMANA',
  'eOCEAN',
  'eALPHA',
  'eNPXS',
  'eKNC',
  'eREEF',
  'eLSK',
  'eQNT',
  'eNXM',
  'eZEN',
  'eHNT',
  'eANT',
  'eCELO',
  'eSNT',
  'eONE',
  'eCKB',
  'eKAVA',
  'eARDR',
  'eARK',
  'eSCRT',
  'eSFP',
  'eRIF',
  'eROSE',
  'eTWT',
  'eKMD',
  'eSTEEM',
  'eTOMO',
  'eGLM',
  'eORN',
  'eAMPL',
  'ePOLY',
  'eBAND',
  'eSWAP',
  'ePOLS',
  'eSAND',
  'eNU',
  'eMIR',
  'eSFI',
  'eGNO',
  'eCOTI',
  'eRFOX',
  'eFUN',
  'eREP',
  'eMASK',
  'eINJ',
  'eUBT',
  'eUSD',
  'eUSDC',
  'eUSDT',
  'eCVC',
  'eSRM',
  'eANKR',
  'eNMR',
  'eDNT',
  'eIOTX',
  'eBTS',
  'eSYS',
  'eOGN',
  'eAVA',
  'eNXS',
  'eAION',
  'eHARD',
  'eTRB',
  'eCTK',
  'eWAN',
  'eCELR',
  'eLOOM',
  'eHIVE',
  'eQKC',
  'eAKRO',
  'ePPT',
  'eSTORJ',
  'eAUDIO',
  'eDUSK',
  'eYFII',
  'eCREAM',
  'eMTL',
  'eGHST',
  'eWRX',
  'eBLZ',
  'eMFT',
  'eROOK',
  'eRGT',
  'eKEEP',
  'ePOWR',
  'ePERP',
  'ePAXG',
  'eDPI',
  'eSUPER',
  'eFARM',
  'eRLC',
  'eSTAKE',
  'eRARI',
  'eHXRO',
  'eMAPS',
  'eFRM',
  'eDF',
  'eBZRX',
  'eKP3R',
  'eBAO',
  'eOMI',
  '1INCH',
  'AAVE',
  'BTC',
  'DAI',
  'ETH',
  'LINK',
  'SNX',
  'UNI',
  'YFI',
  'DOT',
  'BNB',
  'AVAX',
  'CRV',
  'LTC',
  'BCH',
  'DOGE',
  'CAKE',
  'ADA',
  'XRP',
  'XLM',
  'DASH',
  'XMR',
  'ATOM',
  'SUSHI',
  'BADGER',
  'LRC',
  'BAL',
  'RUNE',
  'GRT',
  'FIL',
  'XEM',
  'HEGIC',
  'SOL',
  'BNT',
  'DODO',
  'MKR',
  'NEO',
  'EOS',
  'MIOTA',
  'XTZ',
  'THETA',
  'COMP',
  'TRX',
  'OKB',
  'CRO',
  'VET',
  //'LUNA',
  'BSV',
  'HT',
  'FTT',
  'EGLD',
  'KSM',
  'DCR',
  'LEO',
  'CEL',
  'ZIL',
  'STX',
  'ZEC',
  'VGX',
  'NEAR',
  'RVN',
  'ETC',
  'FTM',
  'NEXO',
  'ENJ',
  'UMA',
  'HBAR',
  'CHSB',
  'ICX',
  'MATIC',
  'ZRX',
  'BAT',
  'WAVES',
  'REN',
  'IOST',
  'ALGO',
  'BTT',
  'ONT',
  'AMP',
  'DGB',
  'NANO',
  'ZKS',
  'OMG',
  'QTUM',
  'AR',
  'MDX',
  'CHZ',
  'HOT',
  'RSR',
  'EWT',
  'SC',
  'MANA',
  'OCEAN',
  'ALPHA',
  'NPXS',
  'KNC',
  'REEF',
  'LSK',
  'QNT',
  'NXM',
  'ZEN',
  'HNT',
  'ANT',
  'CELO',
  'SNT',
  'ONE',
  'CKB',
  'KAVA',
  'ARDR',
  'ARK',
  'SCRT',
  'SFP',
  'RIF',
  'ROSE',
  'TWT',
  'KMD',
  'STEEM',
  'TOMO',
  'GLM',
  'ORN',
  'AMPL',
  'POLY',
  'BAND',
  'SWAP',
  'POLS',
  'SAND',
  'NU',
  'MIR',
  'SFI',
  'GNO',
  'COTI',
  'RFOX',
  'FUN',
  'REP',
  'MASK',
  'INJ',
  'UBT',
  'USD',
  'USDC',
  'USDT',
  'CVC',
  'SRM',
  'ANKR',
  'NMR',
  'DNT',
  'IOTX',
  'BTS',
  'SYS',
  'OGN',
  'AVA',
  'NXS',
  'AION',
  'HARD',
  'TRB',
  'CTK',
  'WAN',
  'CELR',
  'LOOM',
  'HIVE',
  'QKC',
  'AKRO',
  'PPT',
  'STORJ',
  'AUDIO',
  'DUSK',
  'YFII',
  'CREAM',
  'MTL',
  'GHST',
  'WRX',
  'BLZ',
  'MFT',
  'ROOK',
  'RGT',
  'KEEP',
  'POWR',
  'PERP',
  'PAXG',
  'DPI',
  'SUPER',
  'FARM',
  'RLC',
  'STAKE',
  'RARI',
  'HXRO',
  'MAPS',
  'FRM',
  'DF',
  'BZRX',
  'KP3R',
  'BAO',
  'OMI',
]

export const timeframeOptions = {
  WEEK: '1 week',
  MONTH: '1 month',
  ALL_TIME: 'All time',
}

// token list urls to fetch tokens from - use for warnings on tokens and pairs
export const SUPPORTED_LIST_URLS__NO_ENS = []

// hide from overview list
export const OVERVIEW_TOKEN_BLACKLIST = []

// pair blacklist
export const PAIR_BLACKLIST = [
  '0x013b9b1cc25e3530777d61932b03183375bb97ad', // BNT - WNRG pool hidden: issue#22
]

// token blacklist
export const TOKEN_BLACKLIST = {}

// filling data:
BLACKLISTED_TOKENS.forEach((token) => (TOKEN_BLACKLIST[token.toLowerCase()] = true)) // make it an object for quicker reference

// ticker blacklist
export const TICKERS_PROTECTED = {}

// filling data:
PROTECTED_TICKERS.forEach((ticker) => (TICKERS_PROTECTED[ticker] = true)) // make it an object for quicker reference

/**
 * For tokens that cause erros on fee calculations
 */
export const FEE_WARNING_TOKENS = []

// Referral program removed
// export const REFERRED_USER_SWAP_FEE = 0.27

// For block request time duration
export const BLOCK_REQUEST_TIME = 600

// For router links
export const MENU_LINKS = {
  HOME: {
    to: '/',
    activeKeys: [''],
    text: 'Overview',
  },
  TOKENS: {
    to: 'tokens',
    activeKeys: ['tokens', 'token'],
    text: 'Tokens',
  },
  PAIRS: {
    to: 'pairs',
    activeKeys: ['pairs', 'pair'],
    text: 'Pairs',
  },
  ACCOUNTS: {
    to: 'accounts',
    activeKeys: ['accounts', 'account'],
    text: 'Accounts',
  },
  // Referral program removed
  // AFFILIATE: {
  //   to: 'affiliate-analytics',
  //   activeKeys: ['affiliate-analytics'],
  //   text: 'Affiliate Analytics',
  // },
}

// For energiswap links such as swap, pools etc
export const ENERGISWAP_LINKS = {
  SWAP: {
    name: 'Swap',
    type: 'energiswap',
    link: getEnvironmentVar('ENERGISWAP_URL'),
  },
  POOL: {
    name: 'Pool',
    type: 'energiswap',
    link: getEnvironmentVar('ENERGISWAP_POOL_URL'),
  },
  FARMING: {
    name: 'Farming',
    type: 'energiswap',
    link: getEnvironmentVar('ENERGISWAP_FARMING_URL'),
  },
  // Referral program removed
  // AFFILIATE: {
  //   name: 'Affiliate',
  //   type: 'energiswap',
  //   link: getEnvironmentVar('ENERGISWAP_AFFILIATE_URL'),
  // },
  BRIDGE: {
    name: 'Bridge',
    type: 'energiswap',
    link: getEnvironmentVar('ENERGISWAP_BRIDGE_URL'),
  },
  DOCS: {
    name: 'Docs',
    type: 'help',
    link: getEnvironmentVar('DOCS_URL'),
  },
  DISCORD: {
    name: 'Discord',
    type: 'community',
    link: getEnvironmentVar('DISCORD_URL'),
  },
  TWITTER: {
    name: 'Twitter',
    type: 'community',
    link: getEnvironmentVar('TWITTER_URL'),
  },
}

// Referral program removed
// export const MAX_AFFILIATE_CHART_LENGTH = 365
